import { render, staticRenderFns } from "./PostComment.vue?vue&type=template&id=fa1496dc&"
import script from "./PostComment.vue?vue&type=script&lang=ts&"
export * from "./PostComment.vue?vue&type=script&lang=ts&"
import style0 from "./PostComment.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports